import React, { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import DisplayAPIsException from "../../../../BasicComponents/DisplayAPIsExceptionAlert";
import { logEvent, logException } from "../../../../helper/AppInsightsHelper";
import { getSupportSelector } from "../../../../slices/ExploreProducts.slice";
import { useAppSelector } from "../../../../store/hooks";
import QualityTabCharts from "./QualityTabCharts";
import { ProductViewFiltersContext } from "../../../../pages/ProductView";

export const QualityTab = () => {
  // Properties
  const [searchParams] = useSearchParams();
  const filters = useContext(ProductViewFiltersContext);
  const tenantId = searchParams.get("id");
  const [filteredItems, setFilteredItems] = useState([]);
  const [currentFilter, setCurrentFilter] = useState({
    filterKey: "",
    value: ""
  });
  const [chartFilters, setChartFilters] = React.useState<{ [key: string]: any }>({
    monthYear: "",
    caseAgeBucket: "",
    staffingType: "",
    reopenCount: "",
    transferCount: ""
  });
  const { data, isLoading, error } = useAppSelector(getSupportSelector);
  // Events
  const HandleAPIExcpetion = () => (error && <DisplayAPIsException height={250} />) || "";

  const customProps = {
    productName: filters?.productName,
    productFilters: JSON.stringify(filters)
  };

  // Hooks
  useEffect(() => {
    logEvent("Quality Tab - Support", "Product View Page", "QualityTab", customProps);
  }, []);

  useEffect(() => {
    setFilteredItems(data?.qualityTabSupportData?.data ?? []);

    if (error) {
      logException(
        "Product View Page - Support Tab - Quality Sub Tab",
        "QualityTab",
        "useGetSupportDataSummaryByProductIdMutation",
        error
      );
    }
  }, [data, error]);

  useEffect(() => {
    const filteredData = (data?.qualityTabSupportData?.data || []).filter(
      ({ monthYear, caseAgeBucket, staffingType, reopenCount, transferCount }: any) => {
        const filters: { [key: string]: any } = {
          ...chartFilters,
          [currentFilter.filterKey]: currentFilter.value
        };
        if (!currentFilter.filterKey) {
          return true;
        }
        return (
          (filters.monthYear === undefined || filters.monthYear === monthYear) &&
          (filters.caseAgeBucket === undefined || filters.caseAgeBucket === caseAgeBucket) &&
          (filters.staffingType === undefined || filters.staffingType === staffingType) &&
          (filters.reopenCount === undefined || filters.reopenCount === reopenCount) &&
          (filters.transferCount === undefined || filters.transferCount === transferCount)
        );
      }
    );
    setFilteredItems(filteredData);
    setChartFilters(() => {
      if (!currentFilter.filterKey) {
        return {
          monthYear: undefined,
          caseAgeBucket: undefined,
          staffingType: undefined,
          reopenCount: undefined,
          transferCount: undefined
        };
      }
      return {
        ...chartFilters,
        [currentFilter.filterKey]: currentFilter.value
      };
    });
  }, [currentFilter, data?.qualityTabSupportData?.data]);

  return (
    <>
      <QualityTabCharts
        loading={isLoading}
        onSelectedChartFilter={setCurrentFilter}
        tenantId={tenantId}
        tenantName=""
        filteredData={filteredItems}
        kustoLinks={data?.qualityTabSupportData?.kustoLinks}
      />

      <HandleAPIExcpetion />
    </>
  );
};
